/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessDefinition } from '../../models/process-definition';

export interface GetProcessDefinition$Params {
  definitionName: string;
}

export function getProcessDefinition(http: HttpClient, rootUrl: string, params: GetProcessDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessDefinition>> {
  const rb = new RequestBuilder(rootUrl, getProcessDefinition.PATH, 'get');
  if (params) {
    rb.path('definitionName', params.definitionName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessDefinition>;
    })
  );
}

getProcessDefinition.PATH = '/processes/definitions/{definitionName}';
